// User menu dropdown component for header

import { useNavigate } from 'react-router'
import { useAuthStore } from '@/stores/authStore'
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { formatRC } from '@/utils/formatters'
import { User, LogOut, RefreshCw } from 'lucide-react'

export function UserMenu() {
  const navigate = useNavigate()
  const { user, logout, refreshRC } = useAuthStore()

  if (!user) return null

  const handleProfileClick = () => {
    navigate(`/@${user.username}`)
  }

  const handleLogout = () => {
    logout()
    navigate('/auth')
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-10 w-10 rounded-full touch-manipulation">
          <Avatar className="h-10 w-10">
            <AvatarImage
              src={`https://steemitimages.com/u/${user.username}/avatar`}
              alt={user.username}
            />
            <AvatarFallback>{user.username[0]?.toUpperCase()}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{user.username}</p>
            <p className="text-xs leading-none text-muted-foreground">
              RC: {formatRC(user.rcPercentage)}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleProfileClick}>
          <User className="mr-2 h-4 w-4" />
          <span>My Profile</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => refreshRC()}>
          <RefreshCw className="mr-2 h-4 w-4" />
          <span>Refresh RC</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>Sign out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
